/**
 * Helpers for working with species records (of the form found in `app.species`).
 */
export class SpeciesService {
    /**
     * Returns the species name with the word "Salmon" removed.
     *
     * e.g. "Chinook Salmon" → "Chinook", "Salmon" → "".
     *
     * @param {{ name?: string|null }} species - A species object from `app.species`.
     * @returns {string} The shortened, friendly species name.
     */
    static shortFriendlyName(species) {
        return String(species?.name ?? "")
            .replace(/\bsalmon\b/gi, "")
            .replace(/\s+/g, " ")
            .trim()
    }
}
